import { Usuario } from '../types';
import { makeCrudObject } from './api';

export default makeCrudObject<Usuario>('usuarios');
